$('body').on('click','.copy_link a', function(e) {
    e.preventDefault();
    var parent = $(this).parents('.form_param_line');
    var val = parent.find('input[type=text]').select();
    document.execCommand("copy");
});